import { atom, useAtom } from 'jotai';
import { XmlCustomer } from '../models/xml/customer';
import { XmlInvoice, XmlInvoiceType } from '../models/xml/invoice';
import { XmlVendor } from '../models/xml/vendor';
import { XmlData } from '../models/xml/xmlInvoices';

const xmlDataAtom = atom<XmlData>(new XmlData());
export const useXmlDataStore = () => {
  const [xmlDataModel, setXmlDataModel] = useAtom(xmlDataAtom);

  const createXmlDataModel = (xmlInvoices: XmlInvoiceType[], scenarioId: string): XmlData => {
    const xmlDataInstance = new XmlData();

    // assign scenario id
    xmlDataInstance.scenarioId = scenarioId;

    // create invoices model
    const xmlInvoicesArray = xmlInvoices.map((invoice) => new XmlInvoice(invoice));
    // create and fill relevant contacts model
    xmlInvoicesArray.forEach((xmlInvoice) => {
      // create contacts s for customer and vendor and add relation for invoices
      const customer = new XmlCustomer(xmlInvoice.details.customer ?? {}, xmlInvoice.id);
      const vendor = new XmlVendor(xmlInvoice.details.vendor ?? {}, xmlInvoice.id);

      if (xmlInvoice.isForContact) {
        // differentiate between contact and contact meant to be sent to API
        customer.shouldBeUpserted = true;
        vendor.shouldBeUpserted = true;

        xmlDataInstance.addUniqueCustomerForUpsert(customer);
        xmlDataInstance.addUniqueVendorForUpsert(vendor);
      }

      xmlDataInstance.addUniqueVendor(vendor);
      xmlDataInstance.addUniqueCustomer(customer);

      xmlDataInstance.addInvoice(xmlInvoice);
    });
    // set xml data model
    setXmlDataModel(xmlDataInstance);

    return xmlDataInstance;
  };

  return {
    createXmlDataModel,
    xmlDataModel,
  };
};
